<ng-container>
  <div
    class="row"
    [class.hidden]="
      config?.isVisibleForm ||
      config?.isVisibleAuditPage ||
      config?.isVisibleHelpPage
    "
  >
    <div class="tw-w-full">
      <div class="card card-custom gutter-b">
        <ng-content select="[before-header]"></ng-content>

        <!-----------------------------------------  Header  ----------------------------------------->
        <app-page-header
          *ngIf="config?.showHeader"
          [title]="config?.title"
          [isForm]="config?.isForm"
          [loading]="config?.loading"
          [showAddBtn]="config?.showAddBtn"
          [showAuditBtn]="config?.showAuditBtn"
          [isShowForm]="config?.isVisibleForm"
          [isAddBtnWithLoading]="config?.isAddBtnWithLoading"
          [showHelpBtn]="config?.showHelpBtn"
          [showDefaultBtns]="config?.showDefaultBtns"
          [showRefreshBtn]="config?.showRefreshBtn"
          [showBackBtn]="config?.showBackBtn"
          [showAddBtnOnlyForSuperAdmin]="config?.showAddBtnOnlyForSuperAdmin"
          [showLoadingBar]="config?.showLoadingBar"
          [showBorderBottom]="config?.showTopHeaderBorderBottom"
          [isAddBtnWithLoading]="config?.isAddBtnWithLoading"
          [titleClass]="input_titleClass"
          (onAdd)="onCreate($event)"
          (onBack)="onClose($event)"
          (onRefresh)="onRefresh($event)"
          (onShowAudit)="onShowAuditPage($event)"
          (onShowFormAudit)="onShowFormAudit($event)"
          (onShowHelp)="onShowHelpPage($event)"
          [display]="display"
        >
          <!-- ng-content -->
          <ng-content
            select="[lastUpdateDatetime]"
            lastUpdateDatetime
          ></ng-content>
          <ng-content select="[before-btns]" before-btns></ng-content>
          <ng-content select="[after-btns]" after-btns></ng-content>
          <ng-content select="[custom-elements]" custom-elements> </ng-content>
          <ng-content select="[scheduled-id]" scheduled-id></ng-content>
          <ng-content select="[recipient-count]" recipient-count></ng-content>
          <ng-content select="[title]" title></ng-content>
        </app-page-header>

        <!-- custom-header -->
        <ng-content select="[custom-header]"></ng-content>

        <!------------------------------------------  Content  ------------------------------------------>
        <div
          class="card card-body page-body"
          [class]="input_bodyClass || 'tw-pt-5'"
        >
          <div class="app-page-content">
            <!-- ng-content -->
            <ng-content select="[custom-content]"></ng-content>

            <ng-container *ngIf="config?.isShowTable">
              <ng-container
                *ngIf="
                  !config?.tableConfig?.isEmpty ||
                  config?.tableConfig.comparisonObjects?.length > 0
                "
              >
                <!----------------------------------- table ----------------------------------->
                <app-dynamic-table
                  [ignoreDisableBtn]="ignoreDisableBtn"
                  [config]="config?.tableConfig"
                  [loading]="config?.loading"
                  [isEmpty]="config?.isEmpty"
                  [hasError]="config?.hasError"
                  [items]="items"
                  (sortObject)="setUrlFromSortItems($event)"
                  (comparisonObjects)="setUrlFromComparisonObjects($event)"
                  (pageNumber)="changePageNumber($event)"
                  (pageSize)="changePageSize($event)"
                  (onSelectAll)="onSelectAll($event)"
                  (clearQueryString)="clearQueryString()"
                  [showParent]="showParent"
                  [defaultFilters]="defaultFilters"
                >
                  <!--  cancel token -->
                  <ng-content select="[cancel-token]"></ng-content>

                  <!--  table body-->
                  <ng-content select="[table-body]"></ng-content>
                </app-dynamic-table>
              </ng-container>

              <!-- empty page -->
              <ng-container
                *ngIf="
                  config?.tableConfig?.isEmpty &&
                  config?.tableConfig.comparisonObjects?.length === 0
                "
              >
                <app-empty></app-empty>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
